<div class="error-header">
  <img class="logo pc" src="assets/images/infocert-logo.svg" />
  <div class="assistenza-documentazione">
    <ng-ui-kit-button
      class="assistenza"
      color="text"
      [label]="'ERROR_PAGE.HEADER.ASSISTENZA' | translate"
      type="button"
      size="md"
      (onClick)="openUrl('support')">
    </ng-ui-kit-button>
    <span class="line ic1-mr-12 ic1-ml-12">|</span>
    <ng-ui-kit-button
      class="assistenza"
      color="text"
      [label]="'ERROR_PAGE.HEADER.DOCUMENTAZIONE' | translate"
      type="button"
      size="md"
      (onClick)="openUrl('docs')">
    </ng-ui-kit-button>
  </div>
</div>

<div class="error-container">
  <div class="text-container">
    <div class="icon-title">
      <img class="icon" src="assets/images/error-icon.svg" />
      <h1 class="title" translate>ERROR_PAGE.TITLE</h1>
    </div>
    <hr class="line ic1-mt-24 ic1-mb-24" aria-hidden="true" />
    <div class="desc ic1-mb-80" translate>ERROR_PAGE.DESC</div>
    <div class="retry-contact">
      <div class="retry" translate>ERROR_PAGE.RETRY</div>
      <ng-ui-kit-button
        class="contact"
        color="text"
        [label]="'ERROR_PAGE.BUTTON' | translate"
        type="button"
        size="md"
        (onClick)="openUrl('support')">
      </ng-ui-kit-button>
    </div>
  </div>
  <img class="error-image pc" src="assets/images/error-page-image.svg" />
  <img
    class="error-image mobile"
    src="assets/images/error-page-image-mobile.svg" />
</div>
